// shipment status, following from be
export const SHIPMENT_STATUS = Object.freeze({
	WAITING_FOR_PAYMENT: 'waiting_for_payment',
	WAREHOUSE_SELECTING: 'warehouse_selecting',
	READY_TO_CREATE_SHIPMENT: 'ready_to_create_shipment',
	READY_TO_BOOK_COURIER: 'ready_to_book_logistic',
	READY_TO_SHIP: 'ready_to_ship',
	PARTIALLY_SHIPPED: 'partially_shipped',
	SHIPPED: 'shipped',
	DELIVERED: 'delivered',
	BOOKING_FAILED: 'booking_failed',
	SHIPPING_FAILED: 'shipping_failed',
	CANCELED: 'canceled',
});

// shipment status options, following from be
export const SHIPMENT_STATUS_OPTIONS = Object.freeze([
	{
		name: 'All statuses',
		value: null,
	},
	{
		name: 'Waiting for payment',
		value: SHIPMENT_STATUS.WAITING_FOR_PAYMENT,
	},
	{
		name: 'Warehouse selecting',
		value: SHIPMENT_STATUS.WAREHOUSE_SELECTING,
	},
	{
		name: 'Ready to create shipment',
		value: SHIPMENT_STATUS.READY_TO_CREATE_SHIPMENT,
	},
	{
		name: 'Ready to book courier',
		value: SHIPMENT_STATUS.READY_TO_BOOK_COURIER,
	},
	{
		name: 'Ready to ship',
		value: SHIPMENT_STATUS.READY_TO_SHIP,
	},
	{
		name: 'Partially shipped',
		value: SHIPMENT_STATUS.PARTIALLY_SHIPPED,
	},
	{
		name: 'Shipped',
		value: SHIPMENT_STATUS.SHIPPED,
	},
	{
		name: 'Delivered',
		value: SHIPMENT_STATUS.DELIVERED,
	},
	{
		name: 'Booking failed',
		value: SHIPMENT_STATUS.BOOKING_FAILED,
	},
	{
		name: 'Shipping failed',
		value: SHIPMENT_STATUS.SHIPPING_FAILED,
	},
	{
		name: 'Canceled',
		value: SHIPMENT_STATUS.CANCELED,
	},
]);
